import { Box } from '@mui/material';
import React from 'react';
/**
 * A wrapper component that conditionally renders hover content in a tree item.
 * By default, this content is hidden and can be displayed via CSS (e.g., on hover).
 *
 * @param {TreeItemHoverContentProps} root0 - Component props.
 * @param {SxProps<Theme>} [root0.sx] - Optional style overrides to customize appearance.
 * @param {React.ReactNode} root0.children - The content to render within the hover container.
 * @returns {JSX.Element} The hidden hover content container for a tree item.
 */
export const TreeItemHoverContent = ({ sx, children }) => {
    return (React.createElement(Box, { sx: [
            {
                display: 'none',
                flexShrink: 0,
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], className: 'tree-item-hover-content' }, children));
};
